let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aB95y")).then(() => parcelRequire('5QzOg'));